import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
    const navigate = useNavigate();
    const { exchangeGoogleSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = m[1];
        exchangeGoogleSession(sessionId)
            .then((user) => {
                toast.success(`Welcome, ${user.name || user.email}`);
                window.history.replaceState(null, "", "/");
                navigate("/", { replace: true });
            })
            .catch(() => {
                toast.error("Google sign-in failed");
                navigate("/login", { replace: true });
            });
    }, [exchangeGoogleSession, navigate]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center">
                <div className="w-10 h-10 border-4 border-[#E53935] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-[#4A5568]">Signing you in…</p>
            </div>
        </div>
    );
};

export default AuthCallback;
